import React, { useState, useEffect } from "react";

import {
    Box,
    Divider,
    Button,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Select,
    MenuItem,
    FormControl,
    FormHelperText,
    InputLabel,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Chip,
    List,
    ListItem,
    Tab
} from '@mui/material';

import {
    TabContext,
    TabList,
    TabPanel
} from "@mui/lab";

// import { LoadingButton } from '@mui/lab';
import { useNavigate } from "react-router-dom"
import { useFormik } from 'formik';

import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../common/CommonSectionHeader"
import CommonRestricted from '../../common/CommonRestricted';
import { useAppContextFeatures } from '../../../context/AppContext';

import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
// import { mergeSchema } from "../../../utils/dataSchema"

import { useUsers, userTypes, targetTypes } from "../../../hooks/api/useUsers";
import { useTranslations } from '../../../hooks/useTranslations';
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";

import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import SmtpSetting from "./section/SmtpSetting"
import MailjetSetting from "./section/MailjetSetting";
import DefaultSetting from "./section/DefaultSetting";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const RenderTabForm = ({
    handleClick,
    clicked,
}) => {
    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={clicked}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleClick} aria-label="lab API tabs example">
                        <Tab label="Default" value="defaultSetting" />
                        <Tab label="SMTP" value="smtpSetting" />
                        <Tab label="Mailjet" value="mailjetSetting" />
                    </TabList>
                </Box>
                <TabPanel value="defaultSetting">
                    <DefaultSetting />
                </TabPanel>
                <TabPanel value="smtpSetting">
                    <SmtpSetting />
                </TabPanel>
                <TabPanel value="mailjetSetting">
                    <MailjetSetting />
                </TabPanel>
            </TabContext>
        </Box>
    )
}

export default function EmailGatewaySetting({
    routeType
}) {

    const { t } = useTranslations({ ns: ["common", "@user", "sidebar"] })

    const { promptMessage } = useSystemPrompt();
    const { setSystemLoading } = useAppContextFeatures()

    // const { isPermissionAllow } = usePermissions(routeType, scopeIds.user.id, scopeTypes.user.driver.id)

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const [clicked, setClicked] = useState('defaultSetting');

    const handleClick = (event, newValue) => {
        setClicked(newValue);
    };

    return (
        <>
            {
                getHtmlHead({ routeType, title: `${t("emailGateway")}` })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={`${t("emailGateway")}`}
                breadcrumbs={[
                    {
                        displayText: `${t("emailGateway")}`,
                        props: {
                            // href: getRoute("users/drivers")
                        }
                    },
                ]}
            />

            {/* {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ? */}
            <RenderTabForm
                handleClick={handleClick}
                clicked={clicked}
            />
            {/* :
                    <CommonRestricted />
            } */}

        </>
    )
}